import { useQuery } from "@tanstack/react-query";

import { RegionsData, getRegionsByCountry } from "utils";

import { COUNTRY_CODE, GET_REGIONS_BY_COUNTRY } from "consts";

export const useGetRegionsByCountry = ({ countryCode }: { countryCode: COUNTRY_CODE }) =>
  useQuery<RegionsData>({
    queryKey: [GET_REGIONS_BY_COUNTRY, countryCode],
    queryFn: ({ signal }) => getRegionsByCountry({ signal, countryCode }),
    enabled: !!countryCode,
    staleTime: 1000 * 60 * 60 * 24 * 30, // 30 days
  });
